export default __webpack_public_path__ + "static/media/polygon-black.e9dc8efe.png";